
import { Button } from "@mui/material"
import { Link } from "react-router-dom"
import apiSafibc from "../../axios/axios"
import { useLoginStore } from "../../store/zustend"

import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { useEffect, useState } from "react";
import ModalContratosProximos from "./ModalContratosProximos";

const Navegacion = () => {

    const { loginStore } = useLoginStore()

    const [modulos, setModulos] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [contratos, setContratos] = useState([])

    const modulosUsuario = async () => {


        try {
            const usrb64 = btoa(loginStore.jtoken.usuario)

            const modulos_usuario = await apiSafibc(`/navegacion/modulos-usuario/${usrb64}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            setModulos(modulos_usuario.data)


        } catch (error) {
            let msg_error = ''
            if (error.response) {
                if (error.response.data.mensaje) {
                    msg_error = error.response.data.mensaje
                } else {
                    msg_error = 'Ocurrió un error al buscar contrato, favor de volver a cargar!'
                }
            }

            //mensaje de toastify
            toast.error(msg_error, toast_config)
        }

    }


    const proximosContratosVecer = () => {

        const buscarContratos = async () => {
            try {
                const iu = loginStore.jtoken.id_usuario
                const contratos = await apiSafibc(`/navegacion/contratos-proximos-vencer?iu=${iu}`,{
                    headers:{
                        'Authorization' : `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                
                setContratos(contratos.data)

                setOpenModal(true)


                //CAMBIAR LA FORMA DE HACER UPDATE A LOS AHORROS QUE SE ABRA LA FECHA Y LA SELECCIONE EL PAGO




            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar contratos proximos vencer, favor de volver a cargar!'
                    }
                }

                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        buscarContratos()



    }

    

    useEffect(() => {

        modulosUsuario()
        proximosContratosVecer()
    }, [])

    const cerrarModal = () => {
        setOpenModal(false);
        setMostrarAlerta(false)
    };

    useEffect(() => {

        const yaMostrado = sessionStorage.getItem("alertaContratos");

        // Solo mostrar si no se ha mostrado y el usuario está logueado
        if (!yaMostrado && loginStore?.auth) {
            setMostrarAlerta(true);
            sessionStorage.setItem("alertaContratos", "true");
        }
    }, [loginStore?.auth])


    const mostrarModalProxContratos = () => {
        proximosContratosVecer()
        setMostrarAlerta(true)
    }

    


    return (
        <div className="container animation">
            <div className="row d-flex justify-content-end mb-5">
                <div className="col-md-6 text-end">
                    <span className="highlighted-alert" onClick={mostrarModalProxContratos}>
                        PRÓXIMOS CONTRATOS A VENCER
                    </span>

                </div>
            </div>
            <div className="row d-flex justify-content-center">
                {
                    modulos.map((modulo) => (
                        <div className="col-md-4 d-flex justify-content-center animation-layout" key={modulo.ruta_mod}>
                            <div className="card-transparent">
                                <div className="card-body text-center">
                                    <Link to={modulo.ruta_mod}>
                                        <img src={modulo.img_mod} alt="" width={'150px'} /><br />
                                    </Link>
                                    <Link to={modulo.ruta_mod}>
                                        <Button variant="contained">{modulo.boton}</Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))

                }
            </div>

            {openModal && mostrarAlerta ? (
                <ModalContratosProximos
                    open={openModal}
                    onClose={cerrarModal}
                    contratos={contratos}

                />

            ): null}

            <ToastContainer position="bottom-center"
                transition={Flip}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>


    )
}

export default Navegacion